<template>
    <div>

        <!-- {{ ayar }} -->
        <div v-if="disable" style="background: white;"><span style="color: red;">Bu öğe pasif olduğundan başvuru
                ekranında görüntülenmeyecektir. </span></div>
        <p class="ma-0">
            <strong style="color: black;" v-html="label"> </strong> <strong v-if="required"
                style="color: red;margin:0px 5px;">*</strong>
        </p>
        <v-input v-model="selectedDate" dense class=" v-text-field v-text-field--is-booted" :rules="listRules"
            :required="required" :hint="hint" :placeholder="placeholder" clearable persistent-hint>
            <template v-slot:default>
                <div class="v-text-field__slot">
                    <input :type="dateType" :value="selectedDate" @input="updateDate($event.target.value)" lang="tr-TR"
                        :min="min" :max="max" />
                     
    <slot name="edit"></slot>

                </div>

            </template>
        </v-input>
    </div>

</template>

<script>
import { dateHtmlSF } from '@/plugins/FieldDataFormat.js'
import { rules } from '@/plugins/custom.js'
export default {
    name: 'VDateHtml',
    data() {
        return {

            clearable: true,
            selectedDate: this.value,
            label: "",
            required: false,
            rules: [],
            placeholder: "Yanıtınız",
            hint: "",
            activePicker: null,
            disable: false,
            max: null,
            min: null,
            dateType: "date"
        };
    },
    props: {
        ayar: {
            // default: '{"title":"","description":""}',
            default() {
                return dateHtmlSF;
            },
            type: Object
        },
        value: {
            type: String,
            default: null
        },

        icon: {
            type: String,
            default: 'mdi-calendar'
        },

        locale: {
            type: String,
            default: 'tr'
        },



    },
    created() {
        this.dataBind(this.ayar);
    },
    watch: {
        // value(val) {
        //     this.selectedDate = val;
        // },
        ayar: {
            immediate: true,
            handler(newVal, oldVal) {

                this.dataBind(newVal);

            },
            deep: true
        }

    },
    methods: {
        updateDate(val) {
            console.log("VAl:", val);
            this.selectedDate = val;
            this.$emit('input', val);
        },
        clearDate() {
            this.selectedDate = null;
            this.$emit('input', null);
        },
        dataBind(json) {


            this.disable = json.disable;
            this.description = json.description;
            this.rules = json?.rules ?? [];
            this.hint = json?.hint ?? "";
            this.label = json.label;
            this.placeholder = json.placeholder;
            this.min = json.min;
            this.max = json.max;
            this.required = json?.required ?? false;
            this.dateType = json.dateType ?? "date";
        },
    },
    computed: {
        listRules() {
            console.log("listRules:", this.rules);
            return this.rules.map(m => rules[m]);

        },
        dateRule() {
            return (v) => !!v || 'Tarih gerekli';
        },
    },
};
</script>

<style scoped>
.custom-date-input {
    border: none;
    width: 100%;
    padding: 10px;
    font-size: 16px;
}
</style>
<style scoped>
input.v-text-field__input {
    border: none;
    outline: none;
    width: 100%;
    padding: 16px 12px;
    font-size: 16px;
}
</style>
